interface Day30MenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}

const Day30Menu: React.FC<Day30MenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={48}
            checked={!clear && displayValue === 48}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Acute Kindey Failure
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={49}
            checked={!clear && displayValue === 49}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Blood Transfusion
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={50}
            checked={!clear && displayValue === 50}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Cardiac Arrest
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={51}
            checked={!clear && displayValue === 51}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Cardiogenic Shock
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={52}
            checked={!clear && displayValue === 52}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Stroke</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={53}
            checked={!clear && displayValue === 53}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Ventricular Septal Defect
          </span>
        </label>
      </li>
    </ul>
  );
};

export default Day30Menu;
